import React from "react";

export default function LeftButton() {
    return (
        <svg width="33" height="33" viewBox="0 0 24 24">
            <title>arrow left</title>
            <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"></path>
        </svg>
    );
}
